import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TableModule } from 'primeng/table';
import {
   DashboardAutoCompletedTaskResponse,
   DashboardAutoCompletionResponse
} from '../../../services/response/user-property-dashboard-response';

@Component({
   selector: 'app-dashboard-auto-completion-breakdown',
   standalone: true,
   imports: [CommonModule, TableModule],
   templateUrl: './auto-completion-breakdown.component.html',
   styleUrls: ['./auto-completion-breakdown.component.scss']
})
export class AutoCompletionBreakdownComponent {
   @Input() autoCompletion: DashboardAutoCompletionResponse | null = null;
   @Input() reportTypeCode: string | null = null;

   @Output() viewTask = new EventEmitter<number>();

   get tasks(): DashboardAutoCompletedTaskResponse[] {
      const tasks = this.autoCompletion?.tasks ?? [];

      if (!this.reportTypeCode) {
         return [];
      }

      return tasks.filter((task) => task.reportTypeCode === this.reportTypeCode);
   }

   get autoCompletedCount(): number {
      return this.tasks.length;
   }

   get emptyReportCount(): number {
      return this.tasks.filter(
         (task) => task.reasonCode === 'AUTO_COMPLETED_EMPTY_REPORT'
      ).length;
   }

   get noBlockingRiskCount(): number {
      return this.tasks.filter(
         (task) => task.reasonCode === 'AUTO_COMPLETED_NO_BLOCKING_RISKS'
      ).length;
   }

   formatBusinessDate(date: string): string {
      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year}`;
   }

   getReasonLabel(reasonCode: string | null | undefined): string {
      switch (reasonCode) {
         case 'AUTO_COMPLETED_EMPTY_REPORT':
            return 'Empty Report';

         case 'AUTO_COMPLETED_NO_BLOCKING_RISKS':
            return 'No Blocking Risks';

         default:
            return 'Auto-Completed';
      }
   }

   getReasonClass(reasonCode: string | null | undefined): string {
      switch (reasonCode) {
         case 'AUTO_COMPLETED_EMPTY_REPORT':
            return 'auto-completion-status-empty';

         case 'AUTO_COMPLETED_NO_BLOCKING_RISKS':
            return 'auto-completion-status-no-risk';

         default:
            return 'auto-completion-status-default';
      }
   }

   onViewTask(task: DashboardAutoCompletedTaskResponse): void {
      if (!task?.taskInstanceId) {
         return;
      }

      this.viewTask.emit(task.taskInstanceId);
   }
}
